import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=22df3b3f&scoped=true"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"
import style0 from "./Video.vue?vue&type=style&index=0&id=22df3b3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df3b3f",
  null
  
)

/* custom blocks */
import block0 from "./Video.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports